import { Button } from "@qn/ui";
import { RefreshCw } from "lucide-react";
import { useT } from "../lib/i18n";
import { forceReload, useUpdateAvailable } from "../lib/update";

/** Shown when a newer version of the app has been deployed. */
export function UpdateBanner() {
  const t = useT();
  const { available } = useUpdateAvailable();
  if (!available) return null;
  return (
    <div
      role="status"
      className="flex items-center justify-center gap-3 bg-[color-mix(in_oklab,var(--accent)_18%,var(--surface))] px-3 py-1.5 text-xs"
    >
      <span>{t("update.available")}</span>
      <Button size="sm" onClick={() => void forceReload()}>
        <RefreshCw className="size-3.5" /> {t("update.reload")}
      </Button>
    </div>
  );
}
